var _ellipse, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabaseSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.75,
    cy: 6.25,
    rx: 10,
    ry: 3.75,
    stroke: "#2177FE",
    strokeWidth: 1.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5527C8.25198 13.7788 9.09292 13.9649 10 14.1026",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15C3.75 16.9123 7.56711 18.4903 12.5 18.721",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22.3027C8.25198 22.5288 9.09292 22.7149 10 22.8526",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 27.5C8.22715 27.5 3.75 25.8211 3.75 23.75L3.75 6.25M23.75 6.25L23.75 13.75",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 25.8929V27.5M21.25 25.8929C19.804 25.8929 18.5301 25.1826 17.7829 24.1041M21.25 25.8929C22.696 25.8929 23.9699 25.1826 24.7171 24.1041M21.25 17.8571C22.6961 17.8571 23.9701 18.5675 24.7173 19.6461M21.25 17.8571C19.8039 17.8571 18.5299 18.5675 17.7827 19.6461M21.25 17.8571V16.25M26.25 18.6607L24.7173 19.6461M16.2505 25.0893L17.7829 24.1041M16.25 18.6607L17.7827 19.6461M26.2495 25.0893L24.7171 24.1041M24.7173 19.6461C25.1591 20.2839 25.4167 21.0504 25.4167 21.875C25.4167 22.6997 25.159 23.4663 24.7171 24.1041M17.7827 19.6461C17.3409 20.2839 17.0833 21.0504 17.0833 21.875C17.0833 22.6997 17.341 23.4663 17.7829 24.1041",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseSetting);
export default __webpack_public_path__ + "static/media/database-setting.a3c0925829f593b0d801def36115d6fd.svg";
export { ForwardRef as ReactComponent };